var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feature-tags"},_vm._l((_vm.sortedTags),function(tag,index){return _c('tag-feature-text',_vm._b({key:tag._id,attrs:{"active":_vm.activeTagIndex === index}},'tag-feature-text',tag,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }